import { validator } from '@ally/validator';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { DATE_PICKER_FORMAT, SERVER_TIMEZONE } from '../../../../constants';
import { getFirstOrLastBusinessDay, isFirstOrLastBusinessDayFrequency, } from '../../../../utils';
dayjs.extend(utc);
dayjs.extend(timezone);
var IsFirstOrLastBusinessDay = function (date, _a) {
    var federalHolidays = _a.holidays.federal, transferType = _a.transferType, frequency = _a.frequency;
    if (transferType !== 'EXTERNAL') {
        return true;
    }
    // If the frequency is not first or last business date return true
    if (!isFirstOrLastBusinessDayFrequency(frequency)) {
        return true;
    }
    var deliveryDate = dayjs.tz(date, DATE_PICKER_FORMAT, SERVER_TIMEZONE);
    var businessDay = getFirstOrLastBusinessDay({
        federalHolidays: federalHolidays,
        date: deliveryDate,
        frequency: frequency,
    });
    return businessDay.format('MM/DD/YYYY') === deliveryDate.format('MM/DD/YYYY');
};
export var IsFirstOrLastBusinessDayErrorMessage = 'Please enter a valid date.';
export var IsFirstOrLastBusinessDayValidator = validator(IsFirstOrLastBusinessDay, IsFirstOrLastBusinessDayErrorMessage);
//# sourceMappingURL=IsFirstOrLastBusinessDay.js.map